import { addOrSubtractDaysFromDate } from '@/utils/date';

const sketchCourse = {
  id: '1',
  image: '/images/courses/4by3/08.jpg',
  badge: {
    text: 'All level',
    class: 'bg-purple text-purple',
  },
  title: 'Sketch from A to Z: for app designer',
  description: 'Proposal indulged no do sociable he throwing settling. This course covers the basics of Sketch for modern app design, from wireframing to prototyping.',
  rating: {
    review: 2500,
    star: 4.2,
  },
  duration: '12h 56m',
  lectures: 15,
  category: { name: 'Web Design' },
  avatar: '/images/avatar/10.jpg',
  studentImage: '/images/courses/4by3/14.jpg',
  name: 'Larry Lawson',
  price: 150,
  originalPrice: 250,
  discount: 40,
  students: 6500,
  label: 'Design',
  instructor: {
    name: 'Larry Lawson',
    avatar: '/images/avatar/10.jpg',
    title: 'Senior UI/UX Designer',
    bio: 'Larry is a design enthusiast with a decade of experience crafting beautiful and user-friendly interfaces for web and mobile applications.'
  },
  whatYouWillLearn: [
    'Fundamentals of Cybersecurity (CIA Triad, Cryptography)',
    'Understanding of AI Security and Vulnerabilities',
    'Hands-on experience with Hardware Security attacks',
    'Knowledge of Security Standards and Defense Mechanisms',
    'Practical skills in network scanning and malware analysis',
  ],  
  curriculum: [
    {
      title: 'Module 1: Introduction to Sketch',
      lectures: [
        { title: 'Getting Started with the Interface', time: '45m' },
        { title: 'Working with Artboards and Pages', time: '1h 15m' },
      ]
    },
    {
      title: 'Module 2: Advanced Techniques',
      lectures: [
        { title: 'Mastering Symbols and Components', time: '2h' },
        { title: 'Prototyping and Animations', time: '1h 30m', isPremium: true },
      ]
    }
  ],
  faqs: [
    { question: 'What version of Sketch is used?', answer: 'We will be using the latest version of Sketch available.' },
    { question: 'Is this course suitable for beginners?', answer: 'Yes, this course is designed for all levels, starting from the absolute basics.' },
  ],
  reviews: [
     {
      name: 'Design Pro',
      avatar: '/images/avatar/03.jpg',
      rating: 5,
      time: addOrSubtractDaysFromDate(5),
      description: 'A must-have course for any aspiring app designer. The instructor is clear and the projects are very practical.',
    },
  ]
};

export default sketchCourse;
